import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import intersperseWith from '@/lib/intersperse';
import {
  Header,
  SortDirection,
  Table,
  flexRender,
} from '@tanstack/react-table';
import { ArrowDown, ArrowUp, ArrowUpDown, EyeOff } from 'lucide-react';

export function TableHeaderCell<TData>({
  // table,
  header,
}: {
  table: Table<TData>;
  header: Header<TData, unknown>;
}) {
  const sort: false | SortDirection = header.column.getIsSorted();
  const nextSort = sort === false ? 'asc' : sort === 'asc' ? 'desc' : 'asc';

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className="w-full justify-start">
            {header.isPlaceholder
              ? null
              : flexRender(header.column.columnDef.header, header.getContext())}
            {header.column.getCanSort() &&
              header.column.getSortIndex() === 0 &&
              (sort === 'desc' ? (
                <ArrowDown size={16} />
              ) : sort === 'asc' ? (
                <ArrowUp size={16} />
              ) : (
                <ArrowUpDown size={16} className="opacity-50" />
              ))}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          {intersperseWith(
            (idx) => (
              <DropdownMenuSeparator key={idx} />
            ),
            [
              header.column.getCanSort() && (
                <DropdownMenuItem
                  key="sort"
                  onClick={() => {
                    header.column.toggleMultiSort();
                  }}
                >
                  {nextSort === 'desc' ? <ArrowDown /> : <ArrowUp />}
                  Sort {nextSort}ending
                </DropdownMenuItem>
              ),
              header.column.getCanHide() && (
                <DropdownMenuItem
                  key="hide"
                  onClick={() => header.column.toggleVisibility(false)}
                >
                  <EyeOff /> Hide
                </DropdownMenuItem>
              ),
            ].filter(Boolean),
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
